<template>

    <form class="search container-fluid" action="#" method="post">

        <input class="siteSearch" type="text" :placeholder="placeholderText" >
        <button type="submit" class="searchSubmit" :style="'background-image:url(' + icon + ');'">
            <span class="sr-only">Submit Search</span>
        </button>

    </form>
	
</template>

<script>
	
	export default {
		name: 'Search',
		
		props: ['placeholderText', 'icon']
	}
	
</script>